<div class="swapa-body container-md flex-grow-1 pt-4 pb-4">
    <div class="row">
        <h1 class="px-3">{{contractDetails?.Title}}</h1>
        <ng-container *ngIf="contractDetails?.PDFDocumentLink">
            <div class="ml-auto align-self-center px-3">
                <a class="swapa-pdf" href="{{contractDetails?.PDFDocumentLink}}" target="_blank"></a>
            </div>
        </ng-container>
    </div>
    <div class="swapa-contract p-0">
        <div class="section-itr" *ngFor="let section of contractSections;let sec = index">
            <div class="swapa-contract" [hidden]="section.IsHiddenSection || (section.ContractItems.length == 1 && section.ContractItems[0].IsHiddenItem)">
                <a class="swapa-contract-header swapa-accordion-prefix h2"
                   href="#{{section.SectionDivId}}"
                   data-toggle="collapse"
                   [attr.aria-expanded]="expanded?true:false" (click)="updateSectionId(section.SectionDivId)">
                    <span name="section" #section [innerHTML]="section.SectionName | searchContract : searchText:sectionCount:MatchDetails:filterMetadata:index:initialLoad:section"></span>
                    <button class="swapa-contract-toggle btn btn-sm btn-link ml-auto pr-0 text-right">
                        <span class="collapse-label-close">Expand Section</span>
                        <span class="collapse-label-open">Collapse Section</span>
                    </button>
                </a>
                <div id="{{section.SectionDivId}}" [ngClass]="expanded?'collapse show':'collapse'">
                    <div class="section-itr" *ngFor="let subSection of section.ContractItems;let subSec=index">
                        <div class="swapa-contract" [hidden]="subSection.IsHiddenItem">
                            <a class="swapa-contract-header swapa-accordion-prefix h4"
                               href="#{{subSection.ContractItemDivId}}"
                               data-toggle="collapse"
                               [attr.aria-expanded]="expanded?true:false">
                                <span id="name-{{subSection.ContractItemDivId}}" name="item" #item [innerHTML]="subSection.ItemTitle | searchContract : searchText:sectionCount:MatchDetails:filterMetadata:index:initialLoad:item"></span>
                            </a>
                            <!--<div id="{{subSection.ContractItemDivId}}" [ngClass]="expanded?'collapse show':'collapse'">
                    <div *ngFor="let format of subSection.ContractItemBody.Fragments">
                        <div class="px-2 py-3">
                            <span name="format" id="contract"
                                  #format [innerHTML]="format.InternalFormat | searchContract : searchText:sectionCount:MatchDetails:filterMetadata:index:initialLoad"></span>
                            <div class="swapa-top-shortcut text-right text-nonselectable">
                                <a class="anchor-scroll btn btn-sm btn-primary ml-auto p-1 mb-2" href="#{{subSection.ContractItemDivId}}">
                                    ↑ Top of Section
                                </a>
                            </div>
                        </div>
                    </div>
                </div>-->
                            <div id="{{subSection.ContractItemDivId}}" class="contract-item" [ngClass]="expanded?'collapse show':'collapse'">
                                <div class="px-3 py-3">
                                    <span name="format" id="contract" [ngClass]="displayRomanListStyle ? 'custom-contract-list-roman' : 'custom-contract-list-numeric'"
                                          #format [innerHTML]="subSection.ContractItemBodyString | searchContract : searchText:sectionCount:MatchDetails:filterMetadata:index:initialLoad:format"></span>
                                    <div class="swapa-top-shortcut text-right text-nonselectable" [hidden]="false">
                                        <a *ngIf="sectionIdStack.length <= 0" class="anchor-scroll btn btn-sm btn-primary ml-auto p-1 mb-2" href="#{{subSection.ContractItemDivId}}">
                                            ↑ Top of Section
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="swapa-top-shortcut text-right text-nonselectable" id="back-{{section.SectionDivId}}" [hidden]="true">
                <a  class="anchor-scroll btn btn-sm btn-primary ml-auto p-2 mb-2" style="color: #fff;" (click)="navigateBack()">
                    ↑ Back
                </a>
            </div>
        </div>

        <div class="modal fade"
             tabindex="-1"
             role="dialog"
             id="contractModal"
             [ngStyle]="{'display':toggleModalDisplay,'background-color':'#00000052'}">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="contractModalLabel">{{popupName}}</h5>
                        <button type="button"
                                class="close swapa-close text-white"
                                data-dismiss="modal"
                                aria-label="Close"
                                (click)="closePopup()"></button>
                    </div>
                    <div class="modal-body">
                        <span [innerHTML]="modalBody"></span>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="closePopup()">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
